/**
 * 手机登录
 */
import React, { Component } from "react";
import loading from 'c-up-loading';
import notification from 'c-notification';

import NumberUtil from '../../lib/util/number';
import lang from '../../lang';

import UserLogin from '../profile/login';
import {hex_md5} from '../../base/md5';
import Cache from 'c-cache';
import CountryView from '../select-country/country-view';

import CheckRegister from '../thirdparty-login/thirdparty/check';
import Register from '../thirdparty-login/thirdparty/register';
import Findpwd from './findpwd/findpwd';
import EmailVerifyCheck from './findpwd/emailverifycheck';

const cache = new Cache({
    prefix: 'pcuplive'
});
const bindType = 17;

class EmailLogin extends Component {
	static defaultProps = {
		userProcess: 'login',
		email: '',
        progress: 'inputEmail'
	}
	constructor(props){
		super(props);
        let initState = {
            showSelect: true,
            userProcess: props.userProcess || 'login',
            email: props.email,
            progress: props.progress || 'inputEmail',
            isResend: false
        };
        let state = Object.assign(initState,props);
        this.state = state;		
	}

    setInitState(state){
        this.setState(state,()=>{
            UP.Global.DA.add({
                eventName: 'emailLoginProgerss_'+this.state.progress,
                action: 'show'
            });
        });
    }
	componentDidMount(){
        if(this.state.progress == 'inputEmail' && this.props.userProcess == 'login'){
            UP.Global.DA.add({
                eventName: 'phoneLoginProgerss_'+this.state.progress,
                action: 'show'
            });
        }
	}

	componentWillUnmount(){
   		$(document.body).off('click');
        this.timer && clearTimeout(this.timer);
   	}

	submitLogin(progress) {
		let self = this;
		let email = this.refs.email.value.trim();
        let isResend = this.state.isResend;
        // let progress = this.state.progress;
        let registerData = {
            email
        };
        let isRegistered,password;
        switch(progress){
            case 'inputEmail':
                if(!this.verifyEmail()){
                    return;
                }

                isRegistered = this.checkRegistered(registerData);
                isRegistered.done((registered) => {
                    if (registered) {
                        $.channel.emit('emailLogin',{
                            email: registerData.email,
                            progress: 'inputPwd'
                        });
                        // this.getProfileForRegister(registerData);
                    } else {
                        // 去注册
                        $.channel.emit('emailRegister',{
                            email: registerData.email,
                            progress: 'register'
                        });
                        
                        
                    }
                });
                break;
            case 'inputPwd':
                if(!this.verify()){
                    return;
                }
                password = this.refs.password.value.trim();
                registerData = {
                    email,
                    password
                };
                isRegistered = this.checkRegistered(registerData);
                isRegistered.done((registered) => {
                    if (registered) {
                        
                        this.getProfileForRegister(registerData);
                    } else {
                        // 去注册
                        $.channel.emit('emailRegister',{
                            email: registerData.email,
                            progress: 'register'
                        });
                    }
                });
                break;
            case 'findpwd':
                if(!this.verifyEmail()){
                    return;
                }

                isRegistered = this.checkRegistered(registerData);
                isRegistered.done((registered) => {
                    if (registered) {
                        let findPromise = new Findpwd({
                            bindType: bindType,
                            thirdId: email
                        }).promise;
                        findPromise.done((data)=>{
                            UP.Global.DA.add({
                                eventName: 'emailLoginProgerss_'+this.state.progress+'SendEmailSuccess',
                                action: 'show'
                            });
                            if(isResend){

                                notification.simple(lang.template('验证邮件已重新发送'));
                            }else{
                               $.channel.emit('emailSendSuccessTip',{
                                    email,
                                    progress: 'emailSendSuccess'
                                }); 
                            }
                            
                            
                        });
                        findPromise.fail((data)=>{
                            UP.Global.DA.add({
                                eventName: 'emailLoginProgerss_'+this.state.progress+'SendEmailFail',
                                action: 'show'
                            });
                            if(data && data.code == '2024'){
                                notification.simple(lang.template('邮箱未注册'));
                            }else if (data && data.code == 4119) {
                                notification.simple('device forbidden');
                            } else if(data && data.code == 4106){
                                 notification.simple(lang.template('邮箱注册，不在白名单'));
                            }else if(data && data.code == 4131){
                                notification.simple(lang.template('邮箱验证次数超过每天限制'));
                            }else{
                                notification.simple(lang.template('系统错误'));
                            }
                        });
                        
                    } else {
                        // 去注册
                        $.channel.emit('emailRegister',{
                            email: registerData.email,
                            progress: 'register'
                        });
                        
                        
                    }
                });
                break;
            case 'register':
            case 'registerEmailSendSuccess':
                if(!this.verify()){
                    return ;
                }
                password = this.refs.password.value.trim();

                registerData = {
                    email,
                    password
                };
                isRegistered = this.checkRegistered(registerData);
                isRegistered.done((registered) => {
                    if (registered) {
                        
                        this.getProfileForRegister(registerData);
                    } else {
                        
                        loading.show({
                            content: lang.template('正在注册')
                        });
                        this.getProfileForNoRegister(registerData);
                    }
                });

                break;
        }
        isRegistered.fail(()=>{
            alert('dd');
        })

	}
	getProfileForRegister = (data)=>{
		let self = this;
        let registerPromise = this.register(data);

        registerPromise.done((data) => {

        	self.isFetching = false;
            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            UP.Global.writeUserInfo(data);

            loading.hide();

            UP.Global.DA.add({
                eventName: 'loginSuccess',
                action: 'show'
            });

            UP.Global.DA.add({
                eventName: 'emailLoginSuccess',
                action: 'click'
            });

            fbq('track', 'LoginSuccess', { oauthtype: 'email'});

            // location.reload();
            
            $.channel.emit("loginSuccess", data);   
            
        });
        
        registerPromise.fail((dataWrap)=>{
            loading.hide();

        	self.isFetching = false;
            if (dataWrap.code == 4119) {
                notification.simple('device forbidden');
            } else {
            	notification.simple(lang.template('帐号或密码错误'));	
            }
            
        });

	}
	getProfileForNoRegister = (data)=>{
		let self = this;
        let registerData = data;
        let registerPromise = this.register(data);
        let isResend = this.state.isResend;

        registerPromise.done((data) => {

        	self.isFetching = false;
            // 邮箱注册成功，真实用户  开启验证模式
            loading.hide();
            
            if(isResend){
                notification.simple(lang.template('验证邮件已重新发送'));
                return;
            }
            UP.Global.DA.add({
                eventName: 'emailRegisterSendCode',
                action: 'show'
            });

            fbq('track', 'emailRegisterSendCode', { oauthtype: 'email'});
            
            $.channel.emit('emailSendSuccessTip',{
                email: registerData.email,
                progress: 'registerEmailSendSuccess',
                password: registerData.password,
                emailCheckCode: data.exmailCheckCode

            });
            
        });
        
        registerPromise.fail((dataWrap)=>{
            loading.hide();
            self.isFetching = false;
            if (dataWrap.code == 4119) {
                notification.simple('device forbidden');
            } else if(dataWrap.code == 4106){
                 notification.simple(lang.template('邮箱注册，不在白名单'));
            }else if(dataWrap.code == 4131){

                notification.simple(lang.template('邮箱验证次数超过每天限制'));
            }else{
            	notification.simple(lang.template('帐号或密码错误'));	
            }    
        });
	}

	handleSubmit = (e)=>{
		if (this.isFetching) {
			return;
		}
        let progress = this.state.progress;
        this.submitLogin(progress);	
		// if (this.verify()) {
		// 	this.isFetching = true;		
		// 	loading.show({
		// 		content: lang.template('正在登录')
		// 	});
			
		// }
	}
	/*
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered = (data)=>{
        let promise = new CheckRegister({
            bindType: bindType,
            thirdId: data.email
        }).promise;

        return promise;
    }

    register = (data)=>{
        let { email, password } = data;
        let promise = new Register({
            bindType: bindType,
            thirdId: email,
            password: hex_md5(password),
        }).promise;

        return promise;
    }

    login = (uid, password)=>{
        let promise = new UserLogin({
            loginType: 2,
            bindType: bindType,
            uid: uid,
            password: password,
        }).promise;

        return promise;
    }

	verify () {
        if(this.verifyEmail() && this.verifyPwd()){
            return true;
        }
        return false;
	}
    verifyEmail(){
        let email = this.refs.email.value.trim();
        let reg = /[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

        if (email == '') {
            notification.simple(lang.template('请输入邮箱'));
            return false;
        } else if (!reg.test(email)){
            notification.simple(lang.template('邮箱格式错误'));
            return ;
        }

        return true; 
    }
    verifyPwd(){
        let password = this.refs.password.value.trim();
        if(password == ''){
            notification.simple(lang.template('请输入登录密码'));
            return false;
        }
        return true;
    }
	goLogin = (e)=>{
        if(this.state.progress == 'emailSendSuccess'){
            //找回密码
            $.channel.emit('emailLogin',{progress:'inputPwd',email: this.state.email})
            
            return ;
        }
        //注册成功
        let promise = new EmailVerifyCheck({
            emailCheckCode: this.state.emailCheckCode
        }).promise;
        promise.done((data)=>{
            $.channel.emit('emailLogin',{progress:'inputPwd',email: this.state.email});
        });
        promise.fail((data)=>{
            if(data.code == 4133){
                notification.simple(lang.template('邮箱未验证'));
            }else{
                notification.simple(lang.template('邮箱验证失败，请重试'));
            }
        });
		
	}
    goResendMail = (moudle)=>{
        if(this.isResended){
            notification.simple(lang.template('不能频繁发送邮件'));
            return;
        }
        this.isResended = true;
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.isResended = false;
        },60000);
        let progress = 'findpwd'
        if(moudle == 'registerSendMail'){
            progress = 'register';
        }
        this.setState({
            isResend: true
        },()=>{
            this.submitLogin(progress);  
        });

        

    }

    forgetPwd = (e)=>{
        let email = this.refs.email.value.trim();
        $.channel.emit('emailFindPwd',{
            email: email,
            progress: 'findpwd',
        }); 
    }

    render() {
    	let userProcess = this.state.userProcess;
        let progress = this.state.progress;

        let $inputEmailDom = (
            <div className="login-form-item">
                <div className="input-wrap">
                    <input 
                        className="input"
                        ref="email"
                        type="text" 
                        placeholder={lang.template('请输入邮箱')} defaultValue={this.state.email}
                    />
                </div>
            </div>
        );
        let $inputPwdDom = (
                <div className="login-form-item">
                    <div className="input-wrap input-split-wrap">
                        <input 
                            className="input"
                            ref="password"
                            type="password"
                            placeholder={lang.template('请输入登录密码')}
                            defaultValue={this.state.password}
                        />
                        {
                            (progress == 'findpwd' || progress == 'register')?
                                null:<div className="sub-btn" onClick={this.forgetPwd.bind(this)}>{lang.template('忘记密码')}</div>
                        }                      
                    </div>
                </div>
        );

        switch(progress){
            case 'inputEmail':
                return (
                    <div className="email-login">
                        <div className="input-box">
                            {$inputEmailDom}
                        </div>
                        <div className="phone-login-btn" onClick={this.handleSubmit.bind(this)}>
                            {lang.template('确定')}
                        </div>
                    </div>
                );
                break;
            case 'inputPwd':
                return (
                    <div className="email-login">
                        <div className="input-box">
                            {$inputEmailDom}
                            {$inputPwdDom}
                        </div>
                        <div className="phone-login-btn" onClick={this.handleSubmit.bind(this)}>
                            {lang.template('确定')}
                        </div>
                    </div>
                );
                break;
            case 'findpwd':
                return (<div className="email-login">
                        <div className="input-box">
                            {$inputEmailDom}
                        </div>
                        <div className="phone-login-btn" onClick={this.handleSubmit.bind(this)}>
                            {lang.template('确定')}
                        </div>
                    </div>);
                break;
            case 'register':
                return (
                        <div className="email-login">
                            <div className="input-box">
                                {$inputEmailDom}
                                {$inputPwdDom}
                            </div>
                            <div className="phone-login-btn" onClick={this.handleSubmit.bind(this)}>
                                {lang.template('确定')}
                            </div>
                        </div>
                    );
                break;
            case 'emailSendSuccess':
                return (
                    <div className="email-login">
                        <div className="input-box">
                            <div className="email-icon"></div>
                            <div className="email-tip">

                                <p dangerouslySetInnerHTML={{__html: lang.template('验证邮件已发送至<i><%=email%></i>请去邮箱确认',{email: this.state.email})}}></p>
                                <div className="hidden">
                                    {$inputEmailDom}
                                </div>
                            </div>
                            <p className="e-not-reveive"><em>{lang.template('未收到邮件')}</em><em className="resend"></em><em onClick={()=>this.goResendMail('findpwd')} className="goresend">{lang.template('重新发送')}</em></p>
                        </div>
                        <div className="phone-login-btn" onClick={this.goLogin.bind(this)}>
                            {lang.template('确认')}
                        </div>
                    </div>

            );
            break;

            case 'registerEmailSendSuccess':
                return (
                    <div className="email-login">
                        <div className="input-box">
                            <div className="email-icon"></div>
                            <div className="email-tip">

                                <p dangerouslySetInnerHTML={{__html: lang.template('验证邮件已发送至<i><%=email%></i>请去邮箱确认',{email: this.state.email})}}></p>
                                <div className="hidden">
                                    {$inputEmailDom}
                                    {$inputPwdDom}
                                </div>
                            </div>
                            <p className="e-not-reveive"><em>{lang.template('未收到邮件')}</em><em className="resend"></em><em onClick={()=>this.goResendMail('registerSendMail')} className="goresend">{lang.template('重新发送')}</em></p>
                        </div>
                        <div className="phone-login-btn" onClick={this.goLogin.bind(this)}>
                            {lang.template('已验证，确认登录')}
                        </div>
                    </div>

            );
            break;
        }
    	
        return (
        	<div className="email-login">
        		<div className="input-box">
            		
            		
                </div>
        		<div className="phone-login-btn" onClick={this.handleSubmit.bind(this)}>
					{lang.template('确定')}
				</div>
        	</div>
        )
    }
}

export default EmailLogin;


// WEBPACK FOOTER //
// ./js/component/email-login/index.js